import supplier from "./../../../services/purchase/supplier"
import { arrayPushOrUpdateByID } from './../../../utils/toolkit';
 
export default {
    namespaced: false,
    state: {
        list: [],
        loading: false,
    },
    getters:{
        loading: state => state.loading ,
        list: state => state.list
    },
    mutations:{
        setLoading : (state, payload) =>   state.loading = payload,
        push : (state, payload) =>  state.list = arrayPushOrUpdateByID(state.list, payload)
    },
    actions: {
        search(context, payload) {
            return new Promise((resolve, reject) => {
                context.commit("setLoading", true);
                supplier.search(payload).then(response => {
                context.commit("push", response.data);
                resolve(response)
            }).catch(error => reject(error))
            .finally(() => {
                context.commit("setLoading", false);
            });

            });
        },
        push(context, payload) {
            context.commit("push", [payload]);
        }
    }
}